import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getViewMAnagementStore = (state: RootState) => state.viewManagementStore;
const loaderVisible = createSelector(getViewMAnagementStore, (state) => state.loaderVisible);

export { loaderVisible };
